/* Component to wrap md-button, this will make it easy to make universal changes.
   This is only in the 'Theme' module so it can be used on the login/password screens without including all of Common
*/

export class ClButtonComponent implements angular.IComponentOptions {
    public bindings: any = {
        autofocus: '@',
        btnKlass: '@btnClass',
        clickAction: '&',
        disabled: '<?ngDisabled',
        icon: '@',
        iconButton: '@',
        iconKlass: '@iconClass',
        materialIcon: '@',
        stopPropagation: '@',
        text: '@btnText',
        tooltipDirection: '@'
    };

    public controller = ClButtonController;

    public template = ['$attrs', ($attrs: angular.IAttributes) => {
        const buttonType = this.getButtonType($attrs);
        const presetClasses = this.getPresetClasses($attrs);

        return `
            <md-button
                    md-autofocus="$ctrl.autofocus"
                    ng-class="$ctrl.btnKlass"
                    ng-click="$ctrl.executeAction($event)"
                    ng-disabled="$ctrl.disabledByAction || $ctrl.disabled"
                    aria-label="{{$ctrl.text}}"
                    ${buttonType}
                    ${presetClasses}>
                <md-icon ng-class="$ctrl.iconKlass" ng-if="$ctrl.icon && !$ctrl.materialIcon" md-svg-icon="{{$ctrl.icon}}"></md-icon>
                <md-icon
                    class="cl-button-material-icon"
                    ng-class="$ctrl.iconKlass"
                    ng-if="$ctrl.materialIcon"
                >
                    {{$ctrl.materialIcon}}
                </md-icon>
                <span ng-if="!$ctrl.iconButton" ng-class="{ 'force-space': $ctrl.icon }">{{$ctrl.text}}</span>
                <md-tooltip ng-if="$ctrl.tooltipDirection" md-direction="{{$ctrl.tooltipDirection}}">
                    {{$ctrl.text}}
                </md-tooltip>
            </md-button>
        `;
    }];

    /* We cannot interpolate the button type or IE11 will put 'submit' on all of them. Very bad! */
    private getButtonType($attrs) {
        const btnType = $attrs['btnType'] || 'button';

        return ` type="${btnType}"`;
    }

    /* Also need to know if it is an icon-button ahead of time -- if it is allowed to go into ng-class it'll cause flickering / jumping */
    private getPresetClasses($attrs) {
        const isIconButton = $attrs['iconButton'];
        const presetClasses = isIconButton ? 'md-icon-button' : '';

        return ` class="${presetClasses}"`;
    }
}

// tslint:disable-next-line:max-classes-per-file
export class ClButtonController implements angular.IComponentController {
    public static $inject: string[] = [
        '$q'
    ];

    /** If this is true, the button will be autofocused, so that, for example, in a dialog, pressing 'Enter' will activate that button */
    private autofocus: boolean = false;

    /**
     * Pass in ng-click behavior as click-action so that it is applied to the md-button and not the cl-button --
     * this is to prevent issues with disabled buttons being able to still perform their behavior
     */
    private clickAction: (args: {
        $event: Event
    }) => any;

    /** If this is true, the button will be disabled. Kept internal to ClButtonController */
    private disabledByAction: boolean = false;

    /** If this is true, the button will be disabled. This one is evaluated from a passed-in expression */
    private disabled: boolean = false;

    /**
     * If this is true, the btnText will be applied to the aria-label but not the span,
     * and the md-icon-button class will be applied to the outer md-button
     */
    private iconButton: boolean = false;

    /** Any classes that exist here will be applied to the outer md-button */
    private btnKlass: string;

    /** The md-icon identifier, anything passed in here must be registered with $mdIconProvider */
    private icon: string;

    /** Any classes that exist here will be applied to the inner md-icon */
    private iconKlass: string;

    /** Any string passed in here will be applied to both the span and the aria-label, UNLESS iconButton is true */
    private text: string;

    /** If this is passed in, the ng-click event will stop propagation */
    private stopPropagation: boolean = true;

    /** If you pass a tooltip direction in, the component will use the btnText passed in to generate a tooltip */
    private tooltipDirection: string;

    private executeAction($event: Event) {
        if (this.stopPropagation) {
            $event.stopPropagation();
        }

        this.disabledByAction = true;

        this.$q.when(this.clickAction({ $event: $event })).finally(() => {
            this.disabledByAction = false;
        });
    }

    constructor(
        private $q: angular.IQService
    ) {
    }
}
